import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="footer">
    <div className="footer-columns">
      <div className="column">
        <h3>Navigation</h3>
        <Link to="/">Home</Link>
        <Link to="/about">About</Link>
        <Link to="/services">Services</Link>
        <Link to="/contact">Contact</Link>
      </div>
      <div className="column">
        <h3>Legal</h3>
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/terms">Terms of Service</Link>
        <Link to="/disclaimer">Disclaimer</Link>
      </div>
      <div className="column">
        <h3>App</h3>
        <a href="http://app.hestialedger.com">Try Now!</a>
        <Link to="/features">Features</Link>
        <Link to="/support">Support</Link>
      </div>
    </div>
    <div className="footer-bottom">
      <p>© 2025 Hestia Ledger. All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;